"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _commonLibs = require("@mmc/common-libs");
var _objectFitImages = _interopRequireDefault(require("object-fit-images"));
var _header = _interopRequireDefault(require("../styles/header-500.css"));
var _header2 = _interopRequireDefault(require("./header-500.props/header-500.propTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageOptimization = dataUtils.appendImageOptimization;
var BackgroundImage = function BackgroundImage(_ref) {
  var data = _ref.data;
  var imgSrc = handleNestedProp(data, 'data.image.image');
  var ref = (0, _react.useRef)();
  var imageWidth = 2160;
  var isBackground = false;
  var isWebp = true;
  var imageQuality = 70;
  var srcSet = imgSrc ? [appendImageOptimization(imgSrc, 240, isBackground, isWebp, imageQuality) + " 240w", appendImageOptimization(imgSrc, 480, isBackground, isWebp, imageQuality) + " 480w", appendImageOptimization(imgSrc, 720, isBackground, isWebp, imageQuality) + " 720w", appendImageOptimization(imgSrc, 1080, isBackground, isWebp, imageQuality) + " 1080w", appendImageOptimization(imgSrc, 1440, isBackground, isWebp, imageQuality) + " 1440w", appendImageOptimization(imgSrc, 2160, isBackground, isWebp, imageQuality) + " 2160w"].join(',') : '';
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: _header["default"].backgroundImageWrapper,
    ref: ref
  }, imgSrc && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    afterLoad: function afterLoad() {
      return (0, _commonLibs.execIE11ImagePolyfills)(ref, _objectFitImages["default"]);
    },
    src: appendImageOptimization(imgSrc, imageWidth, isBackground, isWebp, imageQuality),
    srcSet: srcSet,
    sizes: "100vw",
    width: imageWidth,
    alt: handleNestedProp(data, 'data.image.altText'),
    className: _header["default"].backgroundImage
  }));
};
var _default = BackgroundImage;
exports["default"] = _default;